import { Attachment } from '../../../shared-components/models/attachment.model';
import { CheckInOutSettings } from '../attendance-check-in-out/attendance-check-in-out.model';

export class AttendanceByStudent {
    StudentId: number;
    DailyCalendarId: number;
    AttendanceHistoryId: number;
    SiteSectionId: number;
    AttendanceDate: Date;
    StartPeriod: number;
    Meets: string;
    StartTime: string;
    EndTime: string;
    PeriodAvailable: boolean;
    SubjectSection: string;
    TeacherName: string;
    AttendanceCodeId: number;
    PartialMinutesAbsence: number;
    Lunch: string;
    SubjectTermType: string;
    EntryDate: Date;
    DroppedDate: Date;
    OrgAttendanceCodeId: number;
    OrgPartialMinutesAbsence: number;
    PeriodicComment: string;
    DailyComment: string;
    OrgDailyComment: string;
    MarkedByAdmin: boolean;
    Duration: number;
    AttendanceTypeId: number;
    AttendanceType: string;
    TeacherCanMark: boolean;
    CheckInOutHistoryId: number;

    // Non DTO Fields
    HasFocus: boolean;
    AttendanceCode: string;
    AttenCodeId: string;
    OrgAttendanceCode: string;
    OrgAttenCodeId: string;
    PromptForPartialMinutes = false;
    CanTeacherChangeAtt = true;
}

export class AttendanceByStudentList {
    Attendance: AttendanceByStudent[] = [];
    AttendanceDate: Date;
}

export class AllStudentsAttendanceHistory {
    StudentAttendance: AttendanceByStudent[] = [];
    Attachments: Attachment[] = [];
    CheckInOutHistoryId: number;
    CheckInOutSettings: CheckInOutSettings;
    StudentId: number;
}
